import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'metric-bar',
  templateUrl: './metric-bar.component.html',
  styleUrls: ['./metric-bar.component.scss']
})
export class MetricBarComponent implements OnInit {
  @Input() className;
  @Input() max;
  @Input() name;
  @Input() value;

  constructor() { }

  ngOnInit() {
  }

  toNumber(value) {
    return Number(value).toString();
  }

  /**
   * Given the inputted value, converts it to a currency string.
   */
  toValueString() {
    if (!this.value) {
      return 'N/A';
    }
    let value: any = Number(this.value.toFixed(2));
    if (isNaN(Number(value))) {
      return 'N/A';
    }
    if (value >= 1000000000) {
      value /= 1000000000;
      value = Math.round(value);
      value += 'B';
    } else if (value >= 1000000) {
      value /= 1000000;
      value = Math.round(value);
      value += 'M';
    } else if (value >= 1000) {
      value /= 1000;
      value = Math.round(value);
      value += 'K';
    } else {
      value = Math.round(value);
    }
    if (Number(value) === 0) {
      return 'N/A';
    }
    return `${value}`;
  }
}
